import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDesign } from '../context/DesignContext';
import { TemplateGallery } from '../components/TemplateGallery';
import { ProductCard } from '../components/ProductCard';
import { PRODUCT_UIDS, getProductMeta } from '@flashcard/shared';
import type { ProductUid, Template } from '@flashcard/shared';

export function DesignPage() {
  const { productUid, setProductUid, setFormat, reset } = useDesign();
  const [showTemplates, setShowTemplates] = useState(false);
  const navigate = useNavigate();

  const products = Object.entries(PRODUCT_UIDS) as [string, ProductUid][];

  const handleSelect = (uid: ProductUid) => {
    const meta = getProductMeta(uid);
    setProductUid(uid);
    if (meta) setFormat(meta.format);
  };

  const handleTemplateSelect = (template: Template) => {
    setProductUid(template.productUid as ProductUid);
    const meta = getProductMeta(template.productUid as ProductUid);
    if (meta) setFormat(meta.format);
    setShowTemplates(false);
    navigate('/editor');
  };

  const goToEditor = () => {
    if (productUid) navigate('/editor');
  };

  return (
    <div>
      <h2>Design wählen</h2>
      <p className="text-muted" style={{ marginBottom: '1.5rem' }}>
        Wähle ein Format und gestalte anschließend deine Visitenkarte im Editor.
      </p>

      <div className="product-grid" style={{ marginBottom: '2rem' }}>
        {products.map(([, uid]) => (
          <ProductCard
            key={uid}
            uid={uid}
            selected={productUid === uid}
            onSelect={() => handleSelect(uid)}
          />
        ))}
      </div>

      <div className="grid grid-2" style={{ marginBottom: '2rem', alignItems: 'start' }}>
        <div className="card">
          <h3>Eigene Karte gestalten</h3>
          <p className="text-muted">Texte, Farben, Logo und QR-Code im Editor anpassen.</p>
          <button className="btn btn-primary" onClick={goToEditor} disabled={!productUid} style={{ width: '100%' }}>
            Weiter zum Editor →
          </button>
          {!productUid && <p className="text-muted" style={{ fontSize: '0.8rem', marginTop: '0.5rem' }}>Bitte zuerst ein Format wählen.</p>}
        </div>

        <div className="card">
          <h3>Oder Vorlage wählen</h3>
          <button className="btn btn-secondary" onClick={() => setShowTemplates(!showTemplates)} style={{ marginBottom: '1rem' }}>
            {showTemplates ? 'Vorlagen verstecken' : 'Vorlagen anzeigen'}
          </button>
          {showTemplates && <TemplateGallery onSelect={handleTemplateSelect} />}
        </div>
      </div>

      {productUid && (
        <button className="btn btn-secondary" onClick={reset}>
          Auswahl zurücksetzen
        </button>
      )}
    </div>
  );
}
